import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { NOW_GRADIENT_TOP, NOW_GRADIENT_BOTTOM } from './BrandWordmark';

/**
 * Restrained mesh for the form panel — brand blues, low contrast.
 */
export default function LoginBackground() {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        zIndex: 0,
        background: 'linear-gradient(180deg, #fafbfc 0%, #f4f6f8 100%)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: { xs: 240, sm: 360 },
          height: { xs: 240, sm: 360 },
          borderRadius: '50%',
          top: '-6%',
          right: '-5%',
          background: `radial-gradient(circle, ${alpha(NOW_GRADIENT_TOP, 0.22)} 0%, transparent 70%)`,
          filter: 'blur(56px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: { xs: 280, sm: 400 },
          height: { xs: 280, sm: 400 },
          borderRadius: '50%',
          bottom: '-10%',
          left: '-8%',
          background: `radial-gradient(circle, ${alpha(NOW_GRADIENT_BOTTOM, 0.18)} 0%, transparent 72%)`,
          filter: 'blur(64px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '48%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: 320, sm: 440 },
          height: { xs: 380, sm: 480 },
          borderRadius: '50%',
          background: `radial-gradient(ellipse, ${alpha('#ffffff', 0.9)} 0%, transparent 68%)`,
        }}
      />
    </Box>
  );
}

/** Decorative shapes for the navy brand panel */
export function LoginBrandPanelDecor() {
  return (
    <Box aria-hidden sx={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
      <Box
        sx={{
          position: 'absolute',
          width: 420,
          height: 420,
          borderRadius: '50%',
          top: '-18%',
          right: '-22%',
          border: `1px solid ${alpha('#ffffff', 0.08)}`,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: 280,
          height: 280,
          borderRadius: '50%',
          bottom: '12%',
          left: '-14%',
          background: `radial-gradient(circle, ${alpha(NOW_GRADIENT_TOP, 0.12)} 0%, transparent 70%)`,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: 0.04,
          backgroundImage: `linear-gradient(${alpha('#ffffff', 0.5)} 1px, transparent 1px), linear-gradient(90deg, ${alpha('#ffffff', 0.5)} 1px, transparent 1px)`,
          backgroundSize: '48px 48px',
        }}
      />
    </Box>
  );
}
